<template lang="pug">
  
  transition(
    @enter="enter" 
    @leave="leave" 
    :css="false" 
  )
    
    section#home-welcome(v-show="show").section

      .landing-title-container

        h1(
          ref="title" 
          tabindex="-1" 
          v-html="lang_en['home-welcome-title']"
        ).landing-title

        p( 
          ref="subtitle"
          v-html="landingCopy"
        ).sub-title

</template>

<script>

import { mapState, mapMutations, mapGetters } from 'vuex' 
import { PATHS, HOME } from 'src/config/app' 
import Env from 'src/config/env'
import Scroll from '@/helpers/Scroll'
import { map } from '@/helpers/MathUtils' 
import gsap from 'gsap' 
import BaseSectionMixin from '@/components/home/sections/mixins/BaseSection'

export default {
 
  mixins: [BaseSectionMixin],

  components: {},

  data() {
    return { 
    }
  },

  computed: {

    ...mapState('app', [ 'motion_clamp' ]),
    ...mapGetters('app', ['getSectionById']),
    
    section(){ 
      return this.getSectionById(HOME.SECTIONS.WELCOME)
    },

    landingCopy(){ 
      let prompt = Env.touch_device ? 'Swipe up' : 'Scroll down'
      return `${prompt} ${this.lang_en['home-welcome-copy']}` 
    }
  },

  created(){ },

  mounted() {},

  beforeDestroy() {},

  methods: {

    enter(el, done){

      gsap.killTweensOf([this.$refs.title])

      done()
      
      const ww = window.innerWidth
      const wh = window.innerHeight

      gsap.fromTo([this.$refs.title, this.$refs.subtitle], {
        z: (this.dir === 0) ? 0 : -(ww * 0.2),
        x: (this.dir === 0) ? 0 : (ww * 0.5),
        y: (this.dir === 0) ? 0 : -(wh * 0.65),
        rotationY: (this.dir === 0) ? 0 : 20,
        rotationX: (this.dir === 0) ? 0 : 10,
        opacity:(this.dir === 0) ? 1 : 0
      }, {
        duration: ((this.base_duration * 0.75) * this.motion_clamp),
        delay: ((this.base_duration * 0.5) * this.motion_clamp),
        z: 0,
        x: 0,
        y: 0,
        rotationY: 0,
        rotationX: 0,
        opacity: 1,
        ease: 'expo.out' 
      })
    },

    leave(el, done){

      const ww = window.innerWidth
      const wh = window.innerHeight

      gsap.killTweensOf([this.$refs.title, this.$refs.subtitle])

      gsap.to([this.$refs.title, this.$refs.subtitle], {
        duration: ((this.base_duration * 0.4 ) * this.motion_clamp),
        z: -(ww * 0.2),
        x: (ww * 0.2),
        y: -(wh * 0.3),
        rotationY: 20,
        rotationX: 10, 
        ease: 'expo.in',
        onComplete: done
      })

      gsap.to([this.$refs.title, this.$refs.subtitle], { 
        duration: ( (this.base_duration * 0.36 ) * this.motion_clamp ),
        opacity: 0, 
        ease: 'power3.in'
      }) 
    }
  },

  watch: {
    
  },

}
</script>

<style lang="sass">
@import "src/styles/common.sass"

</style>
